(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  var CODE = "HALLOWEEN";
  var VARIANT = 55778623979864;
  var OLD = 46544400712024;
  var MIN_CENTS = 8999;
  var PROP = "_halloween_yak";
  var RELOAD_KEY = "fc-hyak-2026";
  var STAMP = "fc-hyak-stamp";
  var STAMP_AT = "fc-hyak-stamp-at";
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var busy = false;
  var pending = false;
  var origFetch = window.fetch;

  function urlOf(input) {
    if (typeof input === "string") return input;
    if (input && input.url) return input.url;
    return "";
  }

  function path(p) {
    return root.replace(/\/$/, "") + p;
  }

  function hasCode(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || "").toUpperCase() === CODE) return true;
    }
    return false;
  }

  function isGift(id) {
    return id === VARIANT || id === OLD;
  }

  function otherCents(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (isGift(item.variant_id)) return;
      sum += item.final_line_price || 0;
    });
    return sum;
  }

  function eurCart(cart) {
    return (cart.currency || "EUR") === "EUR" && otherCents(cart) < 1000000;
  }

  function overThreshold(cart) {
    if (!hasCode(cart)) return false;
    if (eurCart(cart)) return otherCents(cart) >= MIN_CENTS;
    return true;
  }

  function stampOf(cart) {
    return String(otherCents(cart)) + "|" + (hasCode(cart) ? "1" : "0");
  }

  function recentlyFailed(cart) {
    if (sessionStorage.getItem(STAMP) !== stampOf(cart)) return false;
    var at = Number(sessionStorage.getItem(STAMP_AT) || 0);
    return Date.now() - at < 30 * 60 * 1000;
  }

  function markFailed(cart) {
    sessionStorage.setItem(STAMP, stampOf(cart));
    sessionStorage.setItem(STAMP_AT, String(Date.now()));
  }

  function isOurs(item) {
    var props = item.properties || {};
    return String(props[PROP] || "") === "1";
  }

  function linesOf(cart, id) {
    return (cart.items || []).filter(function (item) {
      return item.variant_id === id;
    });
  }

  function post(url, body) {
    return origFetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function reloadOnce() {
    if (sessionStorage.getItem(RELOAD_KEY) === "1") {
      sessionStorage.removeItem(RELOAD_KEY);
      return;
    }
    sessionStorage.setItem(RELOAD_KEY, "1");
    location.reload();
  }

  function finish() {
    busy = false;
    if (pending) {
      pending = false;
      sync();
    }
  }

  function sync() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    origFetch(path("/cart.js"), { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var oldOurs = linesOf(cart, OLD).filter(isOurs);
        if (oldOurs.length) {
          return post(path("/cart/change.js"), { id: oldOurs[0].key, quantity: 0 }).then(function (data) {
            if (!data || data.status >= 400) return;
            reloadOnce();
          });
        }
        var lines = linesOf(cart, VARIANT);
        var ours = lines.filter(isOurs);
        var keep = overThreshold(cart);
        if (ours.length && (!keep || ours[0].final_line_price > 0)) {
          if (keep && ours[0].final_line_price > 0) markFailed(cart);
          return post(path("/cart/change.js"), { id: ours[0].key, quantity: 0 }).then(function (data) {
            if (!data || data.status >= 400) return;
            reloadOnce();
          });
        }
        if (keep && lines.length === 0 && !recentlyFailed(cart)) {
          return post(path("/cart/add.js"), {
            id: VARIANT,
            quantity: 1,
            properties: { _halloween_yak: "1" }
          }).then(function (data) {
            if (!data || data.status >= 400) return;
            reloadOnce();
          });
        }
        if (keep && ours.length === 1 && ours[0].quantity > 1) {
          return post(path("/cart/change.js"), { id: ours[0].key, quantity: 1 }).then(function (data) {
            if (!data || data.status >= 400) return;
            reloadOnce();
          });
        }
        if (ours.length && ours[0].final_line_price === 0) {
          sessionStorage.removeItem(STAMP);
          sessionStorage.removeItem(STAMP_AT);
        }
        sessionStorage.removeItem(RELOAD_KEY);
      })
      .catch(function () {})
      .then(finish, finish);
  }

  function schedule() {
    setTimeout(sync, 150);
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var result = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(urlOf(input))) {
        result.then(schedule, function () {});
      }
      return result;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fcHyakUrl = url || "";
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(this._fcHyakUrl || ""))) {
      this.addEventListener("load", schedule);
    }
    return origSend.apply(this, arguments);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", sync);
  else sync();
})();
